import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { loadingStore } from '@pascal/pascal-core';
import { liveConnection } from './liveConnection';

export const SocketConnection = observer(({ children }) => {
  const { isPixiLoaded } = loadingStore;

  useEffect(() => {
    if (isPixiLoaded) {
      liveConnection.handleSocketInit();
    }
  }, [isPixiLoaded]);

  return children;
});
